// @flow
import * as React from 'react';
import { useClient } from '../../hooks/client-context';
import { ButtonProps, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { MedicareCardForm, MedicareCardView, MedicareFormFields } from '@coverright/features';
import { ModalCloseButton } from '@coverright/ui/shared';
import { forwardRef, useState } from 'react';
import { useSaveProfile } from './hooks/use-save-profile';
import { covertDateToSeverFormat } from '@coverright/utils';
import moment from 'moment';
import { withButton } from '../../../../features';
import { Pen } from '@phosphor-icons/react';

const Card = () => {
  const client = useClient();

  const partADate = client.medicarePartAStartedAt ? moment(client.medicarePartAStartedAt).format('L') : '';
  const partBDate = client.medicarePartBStartedAt ? moment(client.medicarePartBStartedAt).format('L') : '';

  return (
    <MedicareCardView values={{
      eligibleName: client.eligibleName || '_____ __________',
      medicareNumber: client.medicareNumber || '____-___-____',
      partADate: partADate || '__/__/____',
      partBDate: partBDate || '__/__/____',
    }} copyButton sx={{
      mr: 4,
      '& .medicare-card-label': {
        lineHeight: '18px',
        fontSize: 10,
      },
      '& .medicare-card-value': {
        lineHeight: '18px',
        fontSize: 11,
      },
    }} />
  );
};

const MedicareCardEditButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const client = useClient();
  const [open, setOpen] = useState(false);
  const { save, loading } = useSaveProfile(data => {});

  const handleSubmit = async (values: MedicareFormFields) => {
    await save({
      medicareNumber: values.medicareNumber?.toUpperCase(),
      medicarePartBStartedAt: covertDateToSeverFormat(values.partBDate) || null,
      medicarePartAStartedAt: covertDateToSeverFormat(values.partADate) || null,
      eligibleName: values.eligibleName,
      profileId: client.profileId,
    });
    setOpen(false);
  }

  const partADate = client.medicarePartAStartedAt ? moment(client.medicarePartAStartedAt).format('L') : '';
  const partBDate = client.medicarePartBStartedAt ? moment(client.medicarePartBStartedAt).format('L') : '';

  return <>
    <Dialog fullWidth maxWidth={'sm'} open={open} onClose={() => setOpen(false)}>
      <DialogTitle variant={'h3'}>
        Medicare card
        <ModalCloseButton onClick={() => setOpen(false)} sx={{position: 'absolute', top: 4, right: 8}} />
      </DialogTitle>
      <DialogContent>
        <MedicareCardForm
          loading={loading}
          initial={{
            ...client,
            partADate,
            partBDate,
          }}
          onSubmit={handleSubmit}
          theme={'dark'}
        />
      </DialogContent>
    </Dialog>
    <IconButton ref={ref} size={'small'} sx={{position: 'absolute', right: 0}} {...props} onClick={e => {
      props.onClick && props.onClick(e)
      setOpen(true)
    }}>
      <Pen color="#a6a6a6" />
    </IconButton>
  </>
})

export const MedicareCard = withButton(
  Card,
  MedicareCardEditButton
)
